import HandballInformation from './Handball';

export { HandballInformation };
